<template>
  <Dialog
    width="680px"
    :height="createRenderType == 'pc' ? '' : ''"
    :mobileRenderType="createRenderType == 'pc' ? '' : 'drawerDialog'"
    :customClass="`${createRenderType}-looking-dialog looking-dialog`"
    titleAlign="left"
    :visible="dialogVisible"
    :isOuterHead="true"
    :hideCloseBtn="true"
    @close="onClose"
  >
    <template #outerhead>
      <div class="dialog-title">
        {{ $$t("credit.looking") }}&nbsp;<span>{{ $$t("credit.as_reference") }}</span
        >?
      </div>
      <div class="prompt-title">
        {{ $$t("credit.this_feature") }}
      </div>
    </template>
    <div class="card-box">
      <div class="desc">{{ $$t("credit.the_basic_plan") }}</div>
      <div class="content-box">
        <div class="explain">
          <div class="explain-item" :class="{ active: index == 1 }" v-for="(item, index) in [0, 1, 2]" :key="index">
            <i></i>
            <div class="text">xxx</div>
          </div>
        </div>
      </div>
      <div class="btn-upd">
        <span class="btn-text-green">{{ $$t("credit.upgrade_to") }}</span
        ><span>{{ $t("credit.yearly") }}</span>
      </div>
      <div class="btn-continue">
        <span class="btn-text-high">{{ $$t("credit.continue_with") }}</span
        ><span>{{ $$t("credit.paying_yearly") }}</span>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import { ref, defineProps, onMounted, watch, defineEmits } from "vue";
import { storeToRefs } from "pinia";
import { getProducts } from "@/api/api/apiCredit.js";
import { $$language, $$t } from "@/i18n/i18n.js";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import moment from "moment";

const createLayoutStore = useCreateLayoutStore();
const { createRenderType } = storeToRefs(createLayoutStore);
const emits = defineEmits(["update:visible", "handleUpgrade"]);

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  upgradeDialogData: {
    type: Object,
    default: () => ({}),
  },
});

const dialogVisible = ref(props.visible);
const creditList = ref([]);
const handleLoading = ref(false);

const onClose = () => {
  dialogVisible.value = false;
  emits("update:visible", false);
};

const getList = () => {
  getProducts("stripe", {
    category: "normal",
  }).then((res) => {
    if (res.code == 200) {
      creditList.value = res?.data?.list || [];
    }
  });
};

const handleUpgrade = (product) => {
  handleLoading.value = true;
  emits("handleUpgrade", product);
};

onMounted(() => {
  getList();
});

onUnmounted(() => {
  handleLoading.value = false;
});
</script>

<style lang="scss" scoped>
.looking-dialog {
  .dialog-title {
    color: #fff;
    text-align: center;
    font-size: 40px;
    font-weight: bold;
    line-height: normal;
    margin-bottom: 18px;
    span {
      color: #ffe95e;
    }
  }
  .prompt-title {
    color: #fff;
    text-align: center;
    font-size: 20px;
    font-weight: normal;
    line-height: normal;
  }
  .card-box {
    .desc {
      padding: 0 32px;
      font-size: 18px;
      font-weight: 500;
      line-height: 26px;
      color: #ffffff;
      text-align: center;
      margin-bottom: 20px;
    }
    .content-box {
      background: rgba(0, 0, 0, 0.1);
      padding: 16px 16px 8px;
      margin: 0 32px 20px;
      border-radius: 12px;
      .explain {
        .explain-item {
          max-width: 50%;
          display: flex;
          align-items: center;
          justify-content: left;
          flex-direction: row;
          margin-bottom: 8px;
          .text {
            color: #fff;
            font-size: 14px;
            font-weight: normal;
            line-height: 22px;
          }
          i {
            display: block;
            width: 22px;
            height: 22px;
            background-image: url(@/assets/img/credit/check.png);
            background-size: 100% 100%;
            margin-right: 8px;
          }
          &.active {
            .text {
              color: #ffe95e;
            }
            i {
              background-image: url(@/assets/img/credit/check-active.png);
            }
          }
        }
      }
    }
    .btn-upd {
      margin: 0 32px 12px;
      text-align: center;
      height: 64px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #000000;
      border-radius: 70px;
      color: rgba(255, 255, 255, 0.8);
      font-size: 16px;
      .btn-text-green {
        font-weight: bold;
        background: linear-gradient(96deg, #a2ff7d 0%, #ffe95e 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-fill-color: transparent;
      }
    }
    .btn-continue {
      margin: 0 32px 12px;
      text-align: center;
      height: 64px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(255, 255, 255, 0.1);
      border-radius: 70px;
      color: rgba(255, 255, 255, 0.5);
      font-size: 12px;
      font-weight: 500;
      margin-bottom: 40px;
      .btn-text-high {
        font-size: 16px;
        font-weight: 500;
        line-height: normal;
      }
    }
  }

  &.pc-looking-dialog {
  }
  &.mobile-looking-dialog {
    .dialog-title {
      font-size: 24px;
      font-weight: bold;
      text-align: left;
      padding: 0 20px;
    }
    .prompt-title {
      text-align: left;
      font-size: 14px;
      font-weight: normal;
      line-height: 1.4;
      margin: 0 20px;
      padding-left: 10px;
      position: relative;
      color: rgba(255, 255, 255, 0.8);
      &::before {
        content: "";
        position: absolute;
        left: 2px;
        top: 6px;
        width: 3px;
        height: 3px;
        border-radius: 3px;
        background-color: rgba(255, 255, 255, 0.8);
      }
    }
    .card-box {
      .desc {
        text-align: left;
        font-size: 14px;
        font-weight: normal;
        line-height: 1.4;
        margin: 0 20px;
        padding-left: 10px;
        position: relative;
        color: rgba(255, 255, 255, 0.8);
        &::before {
          content: "";
          position: absolute;
          left: 2px;
          top: 6px;
          width: 3px;
          height: 3px;
          border-radius: 3px;
          background-color: rgba(255, 255, 255, 0.8);
        }
      }
      .content-box {
        margin: 0 32px 20px;
        .explain {
          .explain-item {
            max-width: 100%;
            margin-bottom: 6px;
          }
        }
      }
      .btn-upd {
        flex-direction: column;
        background: linear-gradient(101deg, #4fdeff 0%, #e675ff 100%);
        border-radius: 70px;
        color: #000000;
        font-size: 14px;
        font-weight: normal;
        .btn-text-green {
          font-size: 16px;
          font-weight: bold;
          color: #000000;
          background: unset;
          -webkit-background-clip: unset;
          -webkit-text-fill-color: unset;
          background-clip: unset;
          text-fill-color: transparent;
        }
      }
      .btn-continue {
        flex-direction: column;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 70px;
        color: rgba(255, 255, 255, 0.5);
        font-size: 12px;
        font-weight: 500;
        margin-bottom: 40px;
        .btn-text-high {
          color: #fff;
          font-size: 16px;
          font-weight: 500;
          line-height: normal;
        }
      }
    }
  }
}
</style>
